import { CloudRain, Sun, Droplets, Clock } from "lucide-react";

// Hyperlocal rain start/stop per city, from the radar-motion engine (radarArrivals.minutecast).
export function hasMinutecast(mc) {
  const list = mc || [];
  const active = list.filter((c) => c.raining || c.starts_min != null);
  return active.length >= 2;
}

function statusOf(c) {
  if (c.raining) {
    return c.ends_min != null
      ? { badge: "#2f7bed", Icon: CloudRain, big: `Ends ~${c.ends_min} min`, sub: c.intensity === "heavy" ? "Heavy rain now" : "Raining now" }
      : { badge: "#2f7bed", Icon: CloudRain, big: "Ongoing", sub: c.intensity === "heavy" ? "Heavy rain now" : "Raining now" };
  }
  if (c.starts_min != null) {
    return { badge: "#f6a21c", Icon: Droplets, big: `Starts ~${c.starts_min} min`, sub: "Rain approaching" };
  }
  return { badge: "#3a4a63", Icon: Sun, big: "Dry", sub: "No rain expected" };
}

export function MinutecastSlide({ minutecast = [] }) {
  const list = (minutecast || []).slice(0, 10);
  if (!list.length) return null;
  return (
    <div data-testid="minutecast-slide" className="relative h-full w-full overflow-hidden" style={{ background: "linear-gradient(140deg, #0e1c33 0%, #0b1526 58%, #0a0f1c 100%)" }}>
      <div className="absolute inset-0 opacity-[0.05]" style={{ backgroundImage: "repeating-linear-gradient(135deg, #fff 0 2px, transparent 2px 28px)" }} />
      <div className="relative flex h-full w-full flex-col px-[52px] py-[30px]">
        <div className="flex items-center gap-2.5">
          <span className="flex items-center gap-2 rounded-full bg-[#2f7bed] px-4 py-1.5 font-oswald text-[17px] font-black uppercase tracking-[0.2em] text-white">
            <Clock className="h-5 w-5" strokeWidth={2.6} /> Minute-Cast
          </span>
        </div>
        <div className="mt-2 font-oswald text-[52px] font-black uppercase leading-none text-white">Rain, To The Minute</div>
        <div className="mt-1 font-plex text-[22px] font-medium text-white/55">When rain starts and ends across Georgia</div>

        <div className="mt-5 grid flex-1 grid-cols-2 gap-x-7 gap-y-3 content-start">
          {list.map((c, i) => {
            const s = statusOf(c);
            return (
              <div key={c.town} className="flex items-center gap-4 rounded-[11px] bg-white/[0.05] px-4 py-3 ring-1 ring-white/10" data-testid={`minutecast-${i}`}>
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-[10px]" style={{ background: s.badge }}>
                  <s.Icon className="h-7 w-7 text-white" strokeWidth={2.3} />
                </span>
                <div className="min-w-0 flex-1">
                  <div className="truncate font-oswald text-[28px] font-bold uppercase leading-none text-white">{c.town}</div>
                  <div className="font-plex text-[19px] font-semibold leading-tight text-white/55">{s.sub}</div>
                </div>
                <div className="shrink-0 whitespace-nowrap font-oswald text-[26px] font-black tabular-nums" style={{ color: c.raining ? "#7fb2ff" : c.starts_min != null ? "#ffd60a" : "#8ea0b8" }}>{s.big}</div>
              </div>
            );
          })}
        </div>

        <div className="mt-3 flex items-center gap-2 font-plex text-[18px] font-medium tracking-wide text-white/50">
          <Clock className="h-5 w-5" /> Radar-estimated to the minute · based on current storm motion
        </div>
      </div>
    </div>
  );
}
